import {useInfiniteQuery, UseInfiniteQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {
    httpGetTeamMembers,
    HttpGetTeamMembersOptions,
    HttpGetTeamMembersResponse
} from '@/features/treatment-requests/teams/http/teams.http'

interface UseGetInfiniteTeamsOptions {
    urlParams: {treatmentRequestId: string}
    params: HttpGetTeamMembersOptions['params']
    options?: Pick<UseInfiniteQueryOptions<HttpGetTeamMembersResponse>, 'enabled'>
}

export const useGetInfiniteTeams = ({urlParams, params, options}: UseGetInfiniteTeamsOptions) => {
    return useInfiniteQuery({
        queryKey: [QUERY_KEYS.TEAM_MEMBERS, urlParams, params.search, params],
        queryFn: ({pageParam = 1}) => httpGetTeamMembers({urlParams, params: {...params, page: pageParam}}),
        ...options,
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })
}
